import React from "react";
import { CustomChip } from "../CustomChip";
import { Box, Chip, Typography } from "@mui/material";
import { CircleNotifications } from "@mui/icons-material";
import { STATUS_CONFIG } from "../../constants/constants";

export interface IActiveInActiveStatusProps {
  status: string;
  size?: "small" | "medium" | "large";
}

export const StatusRenderer: React.FC<IActiveInActiveStatusProps> = (props) => {
  const status = (props.status || "").toLowerCase();
  if (status === "active") {
    return <CustomChip color="success" content={"Active"} size="small" />;
  } else if (status === "inactive") {
    return (
      <CustomChip
        color="warning"
        content={"Inactive"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "job_requested") {
    return <CustomChip color="info" content={"Draft"} size="small" />;
  } else if (status === "job_approval_requested") {
    return (
      <CustomChip color="info" content={"Approval Requested"} size="small" />
    );
  } else if (status === "purchase_order_requested") {
    return <CustomChip color="info" content={"Draft"} size="small" />;
  } else if (status === "purchase_order_approval_requested") {
    return (
      <CustomChip color="info" content={"Approval Requested"} size="small" />
    );
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size="small" />;
  } else if (status === "re-opened") {
    return <CustomChip color="info" content={"Re-Opened"} size="small" />;
  } else if (status === "Inactive") {
    return <CustomChip color="error" content={"Inactive"} size="small" />;
  } else if (status === "new submission") {
    return (
      <CustomChip color="success" content={"New Submission"} size="small" />
    );
  } else if (status === "new") {
    return <CustomChip color="success" content={"New"} size="small" />;
  } else if (status === "request for approval") {
    return (
      <CustomChip
        color="warning"
        content={"Request for approval"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "request for quote") {
    return (
      <CustomChip color="info" content={"Request for quote"} size="small" />
    );
  } else if (status === "approved") {
    return <CustomChip color="success" content={"Approved"} size="small" />;
  } else if (status === "costing_sheet_requested") {
    return (
      <CustomChip
        color="warning"
        content={"Costing Sheet Requested"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "quote received") {
    return <CustomChip color="success" content={"PI"} size="small" />;
  } else if (status === "PI") {
    return (
      <CustomChip
        color="warning"
        content={"PI"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "todo") {
    return <CustomChip color="warning" content={"Todo"} size="small" />;
  } else if (status === "EXPENSE_APPROVAL_REQUESTED") {
    return (
      <CustomChip
        color="warning"
        content={"Expense Approval Requested"}
        size="small"
      />
    );
  } else {
    return <CustomChip color="info" content={status || "N/A"} size="small" />;
  }
};

export const EnquiryStatusRenderer: React.FC<IActiveInActiveStatusProps> = (
  props,
) => {
  const status = (props.status || "").toLowerCase();
  if (status === "open") {
    return <CustomChip color="success" content={"Open"} size="small" />;
  } else if (status === "request for approval") {
    return (
      <CustomChip
        color="warning"
        content={"Request for approval"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size="small" />;
  } else if (status === "inactive") {
    return <CustomChip color="info" content={"Inactive"} size="small" />;
  } else if (status === "new") {
    return <CustomChip color="info" content={"New"} size="small" />;
  } else if (status === "order") {
    return <CustomChip color="info" content={"Order"} size="small" />;
  } else if (status === "request_for_quote") {
    return (
      <CustomChip color="info" content={"Request For Quote"} size="small" />
    );
  } else if (status === "request for quote") {
    return (
      <CustomChip color="error" content={"Request for quote"} size="small" />
    );
  } else if (status === "approved") {
    return <CustomChip color="success" content={"Approved"} size="small" />;
  } else if (status === "quote received") {
    return (
      <CustomChip
        color="warning"
        content={"Quote Received"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "request_for_approval") {
    return (
      <CustomChip
        color="warning"
        content={"Request For Approval"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "New") {
    return (
      <CustomChip
        color="warning"
        content={"New"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "quote") {
    return <CustomChip color="success" content={"Quote"} size="small" />;
  } else if (typeof status === "number") {
    return <CustomChip color="success" content={`R${status}`} size="small" />;
  } else {
    return <CustomChip color="info" content={status || "N/A"} size="small" />;
  }
};

export const JobStatusRenderer: React.FC<IActiveInActiveStatusProps> = (
  props,
) => {
  const status = (props.status || "").toLowerCase();
  if (status === "approved") {
    return <CustomChip color="success" content={"Approved"} size="small" />;
  } else if (status === "requested") {
    return (
      <CustomChip
        color="warning"
        content={"Requested"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else {
    return <CustomChip color="info" content={status || "N/A"} size="small" />;
  }
};
export const TaskStatusRenderer: React.FC<IActiveInActiveStatusProps> = (
  props,
) => {
  const status = (props.status || "").toLowerCase();
  if (status === "todo") {
    return <CustomChip color="warning" content={"TODO"} size="small" />;
  } else if (status === "progress") {
    return <CustomChip color="info" content={"PROGRESS"} size="small" />;
  } else if (status === "hold") {
    return <CustomChip color="error" content={"HOLD"} size="small" />;
  } else if (status === "completed") {
    return <CustomChip color="success" content={"COMPLETED"} size="small" />;
  } else if (status === "archive") {
    return <CustomChip color="error" content={"ARCHIVE"} size="small" />;
  } else if (status === "high") {
    return <CustomChip content="High" size="small" color="error" />;
  } else if (status === "medium") {
    return (
      <CustomChip
        content="Medium"
        size="small"
        color="warning"
        sx={{
          color: "#000",
        }}
        // sx={{
        //   backgroundColor: "#eb5b00 ", // custom yellow
        //   color: "#ffffff",
        // }}
      />
    );
  } else if (status === "low") {
    return (
      <CustomChip
        content="Low"
        size="small"
        sx={{
          backgroundColor: "#5e936c", // custom blue
          color: "#fff",
        }}
      />
    );
  } else {
    return <CustomChip color="info" content={status || "N/A"} size="small" />;
  }
};

export const ReportedStatusRenderer: React.FC<IActiveInActiveStatusProps> = (
  props,
) => {
  const status = (props.status || "").toLowerCase();
  if (status === "true") {
    return <CustomChip color="success" content={"Reported"} size="small" />;
  } else if (status === "false") {
    return <CustomChip color="error" content={"Unreported"} size="small" />;
  } else {
    return <CustomChip color="info" content={status || "N/A"} size="small" />;
  }
};

export const TaskStatus: React.FC<IActiveInActiveStatusProps> = ({
  status,
  size = "large",
}) => {
  const { label, color, bgColor, textColor } = STATUS_CONFIG[status] || {
    label: status,
    color: "#9e9e9e",
    bgColor: "#eeeeee",
    textColor: "#1a1a1a",
  };

  const sizeStyles = {
    small: {
      px: 0.6,
      py: 0.3,
      pr: 1,
      fontSize: 9,
      height: 14,
      dotWidth: 5,
      dotHeight: 14,
      dotMarginRight: 0.8,
    },
    medium: {
      px: 0.8,
      py: 0.4,
      pr: 1.5,
      fontSize: 14,
      height: 18,
      dotWidth: 8,
      dotHeight: 18,
      dotMarginRight: 1,
    },
    large: {
      px: 1,
      py: 0.7,
      pr: 2,
      fontSize: 12,
      height: 22,
      dotWidth: 9,
      dotHeight: 22,
      dotMarginRight: 1.2,
    },
  }[size];

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "8px",
        px: sizeStyles.px,
        py: sizeStyles.py,
        pr: sizeStyles.pr,
        fontSize: sizeStyles.fontSize,
        fontWeight: 550,
        backgroundColor: bgColor,
        color: textColor || "#1a1a1a",
      }}
    >
      <Box
        sx={{
          width: sizeStyles.dotWidth,
          height: sizeStyles.dotHeight,
          borderRadius: "4px",
          backgroundColor: color,
          mr: sizeStyles.dotMarginRight,
        }}
      />
      <Typography
        variant="h5"
        sx={{ fontWeight: 550, fontSize: sizeStyles.fontSize }}
      >
        {label}
      </Typography>
    </Box>
  );
};
